var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "list"
  }, _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("a-icon", {
      style: {
        fontSize: "30px",
        color: _vm.name == item ? "#1890ff" : ""
      },
      attrs: {
        type: item
      },
      on: {
        click: function ($event) {
          return _vm.iconItem(item);
        }
      }
    })], 1);
  }), 0);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };